import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import { withRouter } from 'react-router-dom';
import ResizeDetector from 'react-resize-detector';
// import Dashboards from '../theme/Components/Dashboards';
import Dashboards from 'Theme/Components/Dashboards';

const PrivateLayout = () => {
  const [width, setWidth] = useState(undefined);
  const themeOption = useSelector(state => state.themeOption);

  const onResize = newWidth => {
    setWidth(newWidth);
  };

  const {
    colorScheme,
    enableFixedHeader,
    enableFixedSidebar,
    enableFixedFooter,
    enableClosedSidebar,
    closedSmallerSidebar,
    enableMobileMenu,
    enablePageTabsAlt,
  } = themeOption;

  return (
    <>
      <div
        className={cx(
          `app-container app-theme-${colorScheme}`,
          { 'fixed-header': enableFixedHeader },
          { 'fixed-sidebar': enableFixedSidebar || width < 1250 },
          { 'fixed-footer': enableFixedFooter },
          { 'closed-sidebar': enableClosedSidebar || width < 1250 },
          { 'closed-sidebar-mobile': closedSmallerSidebar || width < 1250 },
          { 'sidebar-mobile-open': enableMobileMenu }
        )}
      >
        <Dashboards />
        {/* <ResizeDetector handleWidth onResize={onResize} /> */}
      </div>
    </>
  );
};

export default withRouter(PrivateLayout);
